document.addEventListener("DOMContentLoaded", () => {
    const navItems = document.querySelectorAll(".bfcm-nav-item"); // 所有导航项
  const modules = document.querySelectorAll(".bfcm-section"); // 所有模块
  const navContainer = document.querySelector(".bfcm-nav-list"); // 导航容器
  const targetHideElement = document.querySelector(".bfcm-nav-box"); // 隐藏导航的区域


navItems.forEach(item => {
  item.addEventListener('click', () => {
    const targetId = item.getAttribute('data-target');
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      // 1. 用 history.replaceState 更新地址栏哈希，不触发默认滚动
      history.replaceState(null, null, `#${targetId}`);
      
      // 2. 仅执行你的自定义滚动逻辑（不受哈希影响）
      window.scrollTo({
        top: targetElement.offsetTop - 80,
        behavior: 'auto' // 保持你的自定义滚动行为
      });
    }

     navItems.forEach(el => {
      el.classList.remove("active")
    });

    item.classList.add("active")
  });
});

  // 监听页面滚动事件
  window.addEventListener("scroll", function () {
    // 1. 隐藏导航逻辑：滚动到 targetHideElement 以上区域时隐藏
    if (targetHideElement) {
      // 避免元素不存在时报错
      const targetHideRect = targetHideElement.getBoundingClientRect();
      // 当 targetHideElement 的顶部 <= 0 时，说明元素已进入视口（滚动到其以上区域）
      const isAboveTargetArea = targetHideRect.top <= 0;
      if (isAboveTargetArea) {
        navContainer.classList.add("active");
      } else {
        navContainer.classList.remove("active");
      }
    }

      const scrollPosition = window.scrollY + 100; // 偏移量
      
      modules.forEach(module => {
        const moduleId = module.id; // 当前模块ID（如module1）
        const moduleTop = module.offsetTop;
        const moduleHeight = module.offsetHeight;
        
        // 检查当前滚动位置是否在该模块范围内
        if (scrollPosition >= moduleTop && scrollPosition < moduleTop + moduleHeight) {
          // 找到data-target等于当前模块ID的导航项
          navItems.forEach(item => {
            if (item.getAttribute('data-target') === moduleId) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          });
        }
      });
  });

  // 初始化触发一次滚动事件，设置初始状态
  window.dispatchEvent(new Event("scroll"));
});